import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface PublicRouteProps {
  children: ReactNode;
}

/**
 * PublicRoute component that redirects authenticated users away from public pages (like login).
 * This prevents authenticated users from accessing login page when using browser back button.
 */
const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If user is authenticated, redirect to dashboard
  // This prevents authenticated users from accessing login page via browser back button
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // User is not authenticated, allow access to public route
  return <>{children}</>;
};

export default PublicRoute;
